import React, { useEffect, useState } from "react";
import {
  Container,
  Table,
  Pagination,
  Form,
  Button,
  Modal,
} from "react-bootstrap";
import {
  addmenuAPI,
  getAllmenuAPI,
  updatemenuAPI,
  deletemenuitemAPI,
} from "../../helpers/api.ts";
import { ToastContainer, toast } from "react-toastify";
import Breadcrumbs from "../../components/Common/Breadcrumb.js";
import Select from "react-select";
import "react-toastify/dist/ReactToastify.css";
import { FaEdit, FaTrashAlt, FaPlus } from "react-icons/fa";
import { Navigate, useNavigate } from "react-router-dom";

const Menu = () => {
  const navigate = useNavigate();
  const [menus, setMenus] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [showModal, setShowModal] = useState(false);
  const [modalType, setModalType] = useState("Add");
  const [formData, setFormData] = useState({
    type: "",
    dish: "",
    cost: "",
  });
  const [menuId, setMenuId] = useState("");

  const userString = localStorage.getItem("user");
  const user = userString ? JSON.parse(userString) : {};
  const hotel_id = user?.hotel?.hotel_id || user?.hotel_id;

  const pageSize = 10;

  const handleModalClose = () => {
    setShowModal(false);
    resetFormData();
  };

  const resetFormData = () => {
    setFormData({
      type: "",
      dish: "",
      cost: "",
    });
  };

  const handleModalShow = (type, menu = {}) => {
    setModalType(type);
    if (type === "Update") {
      setMenuId(menu.id);
      setFormData({
        type: menu.type,
        dish: menu.dish,
        cost: menu.cost,
      });
    }
    setShowModal(true);
  };

  const handleFormChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const handleSubmit = async () => {
    try {
      const payload = {
        ...formData,
        hotel_id,
        createdBy: user.id,
        updatedBy: user.id,
      };

      let response;
      if (modalType === "Add") {
        response = await addmenuAPI(payload);
      } else {
        response = await updatemenuAPI(menuId, { ...payload, hotel_id });
      }

      if (response.success) {
        toast.success(
          modalType === "Add"
            ? "Menu item added successfully"
            : "Menu item updated successfully"
        );

        if (modalType === "Update") {
          setMenus((prevMenus) =>
            prevMenus.map((menu) =>
              menu.id === menuId ? { ...menu, ...formData } : menu
            )
          );
        } else if (modalType === "Add") {
          setMenus((prevMenus) => [...prevMenus, response.data]);
        }
      } else {
        toast.error(response.message || "Action failed");
      }
    } catch (error) {
      toast.error("An error occurred");
      console.error(error);
    } finally {
      handleModalClose();
    }
  };

  const fetchMenus = async () => {
    try {
      const response = await getAllmenuAPI({
        currentPage,
        pageSize,
        hotel_id,
      });

      if (response.success) {
        setMenus(response.data);
        setTotalPages(response.pagination.totalPages);
      } else {
        toast.error(response.message || "Failed to fetch menus");
      }
    } catch (error) {
      toast.error("An error occurred while fetching menus");
      console.error(error);
    }
  };

  const handlePageChange = (pageNumber) => {
    setCurrentPage(pageNumber);
  };

  const handleDelete = async (menuId) => {
    try {
      const response = await deletemenuitemAPI(menuId, {
        hotel_id,
        userId: user.id,
      });

      if (response.success) {
        toast.success("Menu item deleted successfully");
        fetchMenus();
      } else {
        toast.error(response.message || "Failed to delete menu item");
      }
    } catch (error) {
      toast.error("An error occurred while deleting the menu item");
      console.error(error);
    }
  };

  useEffect(() => {
    fetchMenus();
  }, [currentPage]);

  const menuTypes = [
    { value: "Starter", label: "Starter" },
    { value: "Main Course", label: "Main Course" },
    { value: "Dessert", label: "Dessert" },
    { value: "Beverage", label: "Beverage" },
    { value: "Breakfast", label: "Breakfast" },
  ];

  return (
    <div className="container  py-5 px-3 mb-5">
      <ToastContainer />
      <h6 className="mt-5">
        <Breadcrumbs title="Portal" breadcrumbItem="Menu Items" />
      </h6>
      <div className="d-flex justify-content-end flex-column flex-md-row gap-2 mb-3">
        <Button
          variant="primary"
          className="w-100 w-md-auto"
          onClick={() => handleModalShow("Add")}
        >
          <FaPlus />
          Add Menu Item
        </Button>
        <Button
          variant="secondary"
          className="w-100 w-md-auto"
          onClick={() => navigate("/Customer-menu")}
        >
          Back
        </Button>
      </div>

      <div className="table-responsive">
        <Table className="mt-3  table-bordered table-striped">
          <thead className="text-center">
            <tr>
              <th>#</th>
              <th>Type</th>
              <th>Dish</th>
              <th>Cost</th>
              <th>Actions</th>
            </tr>
          </thead>
          <tbody className="text-center">
            {menus.length > 0 ? (
              menus.map((menu, index) => (
                <tr key={menu.id}>
                  <td>{(currentPage - 1) * pageSize + index + 1}</td>
                  <td>{menu.type}</td>
                  <td>{menu.dish}</td>
                  <td>{menu.cost}</td>
                  <td className="d-flex">
                    <Button
                      variant="warning"
                      size="sm"
                      className="me-2"
                      onClick={() => handleModalShow("Update", menu)}
                    >
                      <FaEdit />
                    </Button>
                    <Button
                      variant="danger"
                      size="sm"
                      onClick={() => handleDelete(menu.id)}
                    >
                      <FaTrashAlt />
                    </Button>
                  </td>
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan="5" className="text-center">
                  No menu items found
                </td>
              </tr>
            )}
          </tbody>
        </Table>
      </div>

      <div className="d-flex justify-content-between align-items-center mt-3">
        <Pagination>
          <Pagination.Prev
            onClick={() => handlePageChange(currentPage - 1)}
            disabled={currentPage === 1}
          />
          {[...Array(totalPages).keys()].map((page) => (
            <Pagination.Item
              key={page + 1}
              active={page + 1 === currentPage}
              onClick={() => handlePageChange(page + 1)}
            >
              {page + 1}
            </Pagination.Item>
          ))}
          <Pagination.Next
            onClick={() => handlePageChange(currentPage + 1)}
            disabled={currentPage === totalPages}
          />
        </Pagination>
      </div>

      {modalType === "Add" || modalType === "Update" ? (
        <Modal
          show={showModal}
          onHide={handleModalClose}
          className="custom-modal modal-fullscreen-md-down"
        >
          <Modal.Header closeButton className="custom-modal-header">
            <Modal.Title>{modalType} Menu Item</Modal.Title>
          </Modal.Header>
          <Modal.Body className="custom-modal-body">
            <Form>
              <Form.Group className="mb-3">
                <Form.Label>Type</Form.Label>
                <Select
                  name="type"
                  value={{
                    label: formData.type,
                    value: formData.type,
                  }}
                  onChange={(selectedOption) =>
                    setFormData({ ...formData, type: selectedOption.value })
                  }
                  options={menuTypes}
                />
              </Form.Group>
              <Form.Group className="mb-3">
                <Form.Label>Dish</Form.Label>
                <Form.Control
                  type="text"
                  name="dish"
                  value={formData.dish}
                  onChange={handleFormChange}
                />
              </Form.Group>
              <Form.Group className="mb-3">
                <Form.Label>Cost</Form.Label>
                <Form.Control
                  type="number"
                  name="cost"
                  value={formData.cost}
                  onChange={handleFormChange}
                />
              </Form.Group>
            </Form>
          </Modal.Body>
          <Modal.Footer className="custom-modal-footer">
            <Button variant="secondary" onClick={handleModalClose}>
              Close
            </Button>
            <Button variant="primary" onClick={handleSubmit}>
              {modalType === "Add" ? "Add" : "Update"} Menu Item
            </Button>
          </Modal.Footer>
        </Modal>
      ) : null}
    </div>
  );
};

export default Menu;
